'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.controller("ClassificationCreationPopinController", function ($scope, $applications, $q, $http, $translate, lovService, $notifications, classificationService, contextService) {
  var isEdit = $scope.edit;
  var cible = $scope.cible;
  var classifications = $scope.classifications;
  $scope.moduleSubvention = $applications.isAideSubventionApplication();
  var originalClassification = isEdit || $scope.classification != null ? $scope.classification : {
    nom: null,
    pseudoType: 'SIMPLE',
    type: 'CLASSIFICATION',
    cible: cible,
    affichages: $scope.moduleSubvention ? ['CREATION'] : null
  };
  var classification = $scope.classification = angular.copy(originalClassification);
  $scope.originalClassification = angular.copy(originalClassification);
  var labelNommageCible = "?";
  if (cible === 'PRODUIT') {
    if ($scope.moduleSubvention) {
      labelNommageCible = "subvention";
    } else {
      labelNommageCible = "produit";
    }
  } else {
    labelNommageCible = cible === 'COMPTE' ? "entité" : cible === 'PROJET' ? "projet" : "contrepartie";
  }
  $scope.typesClassification = [];
  $scope.typesClassification.push({
    id: 'SIMPLE',
    label: "Une valeur par " + labelNommageCible
  });
  if (cible !== 'CONTREPARTIE') {
    $scope.typesClassification.push({
      id: 'MULTIPLE',
      label: "Plusieurs valeurs par " + labelNommageCible
    });

    // pour le moment pas de classif répartissables sur le module subvnetion
    if (!$scope.moduleSubvention) {
      $scope.typesClassification.push({
        id: 'REPARTITION',
        label: "Valeurs répartissables en % par " + labelNommageCible
      });
    }
  }
  $scope.saisieValide = function () {
    return false;
  };
  $scope.nomExistant = function () {
    return _.some(classifications, function (c) {
      return $scope.classification.nom === c.nom && $scope.classification.id !== c.id;
    });
  };
  $scope.classificationFormConfig = {
    url: function url() {
      return '/rest/saisie/champAdditionnel';
    },
    data: function data() {
      return classification;
    },
    fieldPrefix: "classification.",
    customValidation: function customValidation() {
      var errors = [];
      if ($scope.classification.nom == null || $scope.classification.nom.trim().length === 0) {
        errors.push({
          fieldName: 'nom',
          message: 'Le nom est obligatoire.'
        });
      }
      if ($scope.classification.nom !== null && $scope.nomExistant()) {
        errors.push({
          fieldName: 'nom',
          message: 'Il existe déjà une classification portant ce nom.'
        });
      }
      return errors;
    },
    onSuccess: function onSuccess(savedClassification) {
      _.extend(classification, savedClassification);
      classificationService.$reload();
      // on change la structure (nombre de filtres du contexte), il faut donc rechager le contexte
      contextService.reloadContext();
      contextService.refreshData();
      $notifications.info("Classification enregistrée");
      $scope.$close(classification);
    },
    onError: function onError(errors) {}
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/classification/classificationCreationPopin.js
// module id = 2689
// module chunks = 13